export default function script(response) {
  if(typeof(response) == 'string'){
    response = JSON.parse(response);
  }
  let respData = response.data ? response.data : {};
  if(typeof(respData) == 'string'){
    respData = JSON.parse(respData);
  }
    if ((respData.status == "2000" || response?.status == "200" ||  response?.status == "201") && respData.error == null && respData?.status != "4020") {
      let success = true;
      let failure = false;
  
      respData.success = success;
      respData.failure = failure;
  
      return respData;
    } else {
      let success = false;
      let failure = true;
  
      respData.success = success;
      respData.failure = failure;
  
      return respData;
    }
  }
  